import { createAsyncThunk } from '@reduxjs/toolkit';
import { triggerService } from '../../services';

const getTriggers = createAsyncThunk(
    'trigger/getTriggers',
    async (payload, thunkAPI) => {
        try {
            const response = await triggerService.triggersEngagement(
                payload.companyId,
                payload.startRange,
                payload.endRange,
                payload.isUnified
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getTriggersDetails = createAsyncThunk(
    'trigger/getTriggersDetails',
    async (payload, thunkAPI) => {
        try {
            const response = await triggerService.triggerEngagement(
                payload.companyId,
                payload.triggerName,
                payload.startRange,
                payload.endRange,
                payload.isDTC
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getTriggerEngagementPaginate = createAsyncThunk(
    'trigger/getTriggerEngagementPaginate',
    async (payload, thunkAPI) => {
        try {
            const response = await triggerService.triggerEngagementPaginate(
                payload.companyId,
                payload.triggerName,
                payload.startRange,
                payload.endRange,
                payload.batchNo,
                payload.batchSize
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getAllTriggers = createAsyncThunk(
    'trigger/getAllTriggers',
    async(payload, thunkAPI) => {
        try {
            const response = await triggerService.getAllTriggers(payload.companyId);
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getDataInputs = createAsyncThunk(
    'trigger/getDataInputs',
    async(payload, thunkAPI) => {
        try {
            const response = await triggerService.dataInputs(payload.companyId);
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getQueryPreview = createAsyncThunk(
    'trigger/getQueryPreview',
    async(payload, thunkAPI) => {
        try {
            const response = await triggerService.getQueryPreview(payload.companyId, payload.data);
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getTriggerById = createAsyncThunk(
    'trigger/getTriggerById',
    async(payload, thunkAPI) => {
        try {
            const response = await triggerService.getTriggerById(payload.companyId, payload.triggerId);
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const createTrigger = createAsyncThunk(
    'trigger/createTrigger',
    async(payload, thunkAPI) => {
        try {
            const response = await triggerService.createTrigger(payload.companyId, payload.data);
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error?.response?.data);
        }
    }
);

const updateTriggerById = createAsyncThunk(
    'trigger/updateTriggerById',
    async(payload, thunkAPI) => {
        try {
            const response = await triggerService.updateTriggerById(payload.companyId, payload.triggerId, payload.data);
            return response.data;

        } catch (error) {
            
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteQuery = createAsyncThunk(
    'trigger/deleteQuery',
    async(payload, thunkAPI) => {
        try {
            const response = await triggerService.deleteQuery(payload.companyId, payload.data);
            return response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getTriggersSummaryPaginate = createAsyncThunk(
    'trigger/getTriggersSummaryPaginate',
    async (payload, thunkAPI) => {
        try {
            const response = await triggerService.getTriggersSummaryPaginate(
                payload.companyId,
                payload.startRange,
                payload.endRange,
                payload.batchNo,
                payload.batchSize,
                payload.isUnified,
                payload.triggerNames,
                payload.type
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getTriggersSummaryGraphs = createAsyncThunk(
    'trigger/getTriggersSummaryGraphs',
    async (payload, thunkAPI) => {
        try {
            const response = await triggerService.getTriggersSummaryGraphs(
                payload.companyId,
                payload.startRange,
                payload.endRange,
                payload.isUnified,
                payload.triggerNames
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getWebMatrixPatientTrigger = createAsyncThunk(
    'trigger/getWebMatrixPatientTrigger',
    async (payload, ThunkAPI) => {
        try{
            const response = await triggerService.getWebMatrixPatientTrigger(
                payload.companyId,
                payload.startRange, 
                payload.endRange,
                payload.triggerName
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getWebMatrixPatientAnalysisSummaryTrigger = createAsyncThunk(
    'trigger/getWebMatrixPatientAnalysisSummaryTrigger',
    async (payload, ThunkAPI) => {
        try{
            const response = await triggerService.getWebMatrixPatientAnalysisSummaryTrigger(
                payload.companyId,
                payload.startRange, 
                payload.endRange,
                payload.page_no,
                payload.page_size,
                payload.triggerName
            );
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

export { 
    getTriggers, 
    getTriggersDetails, 
    getTriggerEngagementPaginate, 
    getAllTriggers, 
    getDataInputs, 
    getQueryPreview, 
    getTriggerById,
    createTrigger,
    updateTriggerById,
    deleteQuery,
    getTriggersSummaryPaginate,
    getTriggersSummaryGraphs,
    getWebMatrixPatientTrigger,
    getWebMatrixPatientAnalysisSummaryTrigger
};